import { render } from "./UpdateCompanyNumbers.vue?vue&type=template&id=15397710"
import script from "./UpdateCompanyNumbers.vue?vue&type=script&lang=js"
export * from "./UpdateCompanyNumbers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__